import { axios } from '@Root/API'

export const remove = id => {
	return axios.delete(`/program-awarding-body/${id}/delete`)
}
